import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const Fetch = async (url, setNewData) => {
  const navigate = useNavigate();
  if (url) {
    try {
      const res = await axios(
        setNewData?.limit
          ? `${url}?page=${setNewData?.page + 1}&limit=${setNewData?.limit}${
              setNewData?.search ? `&search=${setNewData?.search}` : ""
            }${setNewData?.query ?? ""}`
          : url,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/app.js",
          },
        }
      );
      setNewData(res?.data?.data);
    } catch (err) {
      if (err?.response?.status == 401) {
        navigate("/login");
        localStorage.setItem("isLogged", false);
      } else {
        toast.error(err.response?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  }
};
